import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1a155613")

_pushScopeId("data-v-1a155613")
const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "pi pi-plus" }, null, -1)
const _hoisted_2 = { class: "form-row margin-top-20 margin-bottom-20" }
const _hoisted_3 = { class: "form-row margin-top-20 margin-bottom-20" }
const _hoisted_4 = { class: "button-row flexbox-row justify-space-between" }
const _hoisted_5 = { class: "flexbox-row" }
_popScopeId()

import { CALENDAR_USERS_PAGE_SIZE } from "@/constants/constants.constants";
import {
  emptyNewMembershipErrors,
  emptyNewMembershipForm,
  emptyPadelUser,
} from "@/constants/initial-values.constants";
import UiButton from "../ui/UiButton.vue";
import { PadelUser } from "@/models/user.models";
import {
  returnSearchUserDropdownChoices,
  uppercase,
} from "@/services/mapping.service";
import { ActionTypes } from "@/store/action-types";
import { useStore } from "@/store/store";
import moment from "moment";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { showSuccessToast, showToast } from "@/services/error-management.service";

export default _defineComponent({
  emits: ['updated'],
  setup(__props, { emit }) {

const { t } = useI18n();
const store = useStore();
const searchPlaceholder = ref(null);
const searchOptions = ref([]);
const newMembershipForm = ref({ ...emptyNewMembershipForm });
const newMembershipErrors = ref({ ...emptyNewMembershipErrors });
const isVisible = ref(false);



/* COMPUTED */
const myClubId = computed(function (): string {
  return store.getters.getMyClub.club_id;
});

/* METHODS */
async function searchUsers(event: string) {
  searchPlaceholder.value = event;
  try {
    const usersArray = await store.dispatch(ActionTypes.GET_USERS, {
      club_id: myClubId.value,
      filters: { page_size: CALENDAR_USERS_PAGE_SIZE, name: event },
    });
    if (usersArray.data.records.length > 0) {
      newMembershipErrors.value.wesmash_user = null;
      //POPOLAMENTO DROPDOWN CHOICES
      searchOptions.value = returnSearchUserDropdownChoices(
        usersArray.data.records
      );
    } else {
      newMembershipErrors.value.wesmash_user = t("no_user_found");
      searchOptions.value = [];
    }
  } catch (error) {
    return;
  }
}

function handleSearchClose() {
  searchOptions.value = null;
  searchPlaceholder.value = null;
  newMembershipForm.value.wesmash_user = { ...emptyPadelUser };
  newMembershipErrors.value.wesmash_user = null;
}

async function searchValueSelected(event: {
  label: string;
  value: PadelUser;
}) {
  searchPlaceholder.value = event.label;
  newMembershipForm.value.wesmash_user = event.value;
}

function onSearchValidate() {
  setTimeout(() => {
    searchPlaceholder.value = "";
  }, 10);
  searchPlaceholder.value = null;
  handleSearchClose();
}

function hideModal() {
  isVisible.value = false;
}

function updateFormValue(value, field) {
  if (field === 'price') {
    // Converti a numero e assicurati che sia positivo
    const numericValue = parseFloat(value) || 0;
    newMembershipForm.value[field] = numericValue > 0 ? numericValue : 0;

    // Resetta l'errore se il valore è valido
    if (numericValue > 0) {
      newMembershipErrors.value.price = null;
    }
  } else {
    newMembershipForm.value[field] = value;
  }
}

async function createMembership() {
  try {
    const payload = {
      clubId: myClubId.value,
      userId: newMembershipForm.value.wesmash_user.id,
      description: newMembershipForm.value.description,
      price: newMembershipForm.value.price * 100,
      autoRenewal: false,
      paymentMethod: "CASH",
      status: "active",
      activationDate: moment().toISOString(),
      expirationDate: moment()
        .add(1, "years")
        .toISOString(),
    };
    const response = await store.dispatch(
      ActionTypes.ADD_MEMBERSHIP,
      payload
    );
    showSuccessToast('Membership creata con successo');
    hideModal();
    emit("updated");
  } catch (error: any) {
    console.log(error.response.data.message)
    hideModal()
    showToast(error.response?.data?.message);
    return;
  }
}


return (_ctx: any,_cache: any) => {
  const _component_PadelSearch = _resolveComponent("PadelSearch")!
  const _component_PadelTextarea = _resolveComponent("PadelTextarea")!
  const _component_PadelInput = _resolveComponent("PadelInput")!
  const _component_DumbModal = _resolveComponent("DumbModal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(UiButton, {
      onClick: _cache[1] || (_cache[1] = () => isVisible.value = true),
      variant: "primary",
      "is-text": ""
    }, {
      "right-icon": _withId(() => [
        _hoisted_1
      ]),
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_unref(t)('new_membership')) + " ", 1)
      ]),
      _: 1
    }),
    (isVisible.value)
      ? (_openBlock(), _createBlock(_component_DumbModal, {
          key: 0,
          title: _unref(t)('new_membership'),
          onHide: _cache[7] || (_cache[7] = () => isVisible.value = false)
        }, {
          default: _withId(() => [
            _createVNode(_component_PadelSearch, {
              class: "search-element",
              label: _unref(t)('search_user_name') + '*',
              value: searchPlaceholder.value,
              onOnEnterPressed: _cache[2] || (_cache[2] = ($event: any) => (searchUsers($event))),
              options: searchOptions.value,
              onOnClosePressed: _cache[3] || (_cache[3] = ($event: any) => (handleSearchClose())),
              error: newMembershipErrors.value.wesmash_user,
              onValueClicked: _cache[4] || (_cache[4] = ($event: any) => (searchValueSelected($event))),
              onValidate: onSearchValidate
            }, null, 8, ["label", "value", "options", "error"]),
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_PadelTextarea, {
                class: "textarea",
                label: _unref(t)('description') + '*',
                onInput: _cache[5] || (_cache[5] = ($event: any) => (updateFormValue($event, 'description'))),
                value: newMembershipForm.value.description
              }, null, 8, ["label", "value"])
            ]),
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_PadelInput, {
                class: "input",
                label: _unref(t)('price') + '*',
                type: "number",
                onInput: _cache[6] || (_cache[6] = ($event: any) => (updateFormValue($event, 'price'))),
                value: newMembershipForm.value.price,
                error: newMembershipErrors.value.price
              }, null, 8, ["label", "value", "error"])
            ]),
            _createVNode("div", _hoisted_4, [
              _createVNode(UiButton, {
                variant: "primary",
                "is-text": "",
                onClick: hideModal
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('abort')), 1)
                ]),
                _: 1
              }),
              _createVNode("div", _hoisted_5, [
                _createVNode(UiButton, {
                  label: _unref(t)('confirm'),
                  variant: 'primary',
                  onClick: createMembership,
                  disabled: !newMembershipForm.value.wesmash_user?.id || newMembershipForm.value.description == '' || !newMembershipForm.value.price || newMembershipForm.value.price <= 0
                }, null, 8, ["label", "disabled"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})